<template>
  <div class="wrapper"></div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  computed: {
    user () {
      return this.$store.state.users.user
    },
    users () {
      return this.$store.state.users.all
    }
  },
  mounted () {
    if (navigator.userAgent.match(/iP(hone|od|ad)/)) {
      document.getElementsByName('viewport')[0].setAttribute('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=0')
    } else {
      document.getElementsByName('viewport')[0].setAttribute('content', 'width=device-width, initial-scale=1.0')
    }
  },
  methods: {
    ...mapActions('users', {
      deleteUser: 'delete'
    })
  },
  created () {
    let cookie = document.cookie.match('(^|;) ?aplToken=([^;]*)(;|$)')
    if (cookie) {
      localStorage.setItem('user', cookie)
    }

    this.$store.dispatch('users/getAll')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ROOT.vue